import { Button, DatePicker, Form, Input, Select } from "antd";
const { Option } = Select;
const { RangePicker } = DatePicker;

export const SearchForm = (props) => {
  const { form, handleFilterSubmit, rooms, ratePlans, handleResetFilters } =
    props;
  return (
    <Form form={form} layout="vertical" onFinish={handleFilterSubmit}>
      <div className="row mb-2">
        <div className="col-md-12">
          <Form.Item
            name="search"
            label={<strong>Search by Guest Name, Email, Phone</strong>}
          >
            <Input placeholder="Guest Name, Email, Phone" />
          </Form.Item>
        </div>
        <div className="col-md-6">
          <Form.Item
            name="bookingId"
            label={<strong>Filter by Booking ID</strong>}
          >
            <Input placeholder="Booking ID" />
          </Form.Item>
        </div>
        <div className="col-md-6">
          <Form.Item
            name="transactionId"
            label={<strong>Filter by Transaction ID</strong>}
          >
            <Input placeholder="Transaction ID" />
          </Form.Item>
        </div>
        <div className="col-md-6">
          <Form.Item
            name="startDate"
            label={<strong>Booking On Check-in Date</strong>}
          >
            <DatePicker format="DD-MM-YYYY" />
          </Form.Item>
        </div>
        <div className="col-md-6">
          <Form.Item
            name="endDate"
            label={<strong>Booking On Check-out Date</strong>}
          >
            <DatePicker format="DD-MM-YYYY" />
          </Form.Item>
        </div>
        <div className="col-md-6">
          <Form.Item name="room" label={<strong>Filter by Room</strong>}>
            <Select placeholder="Select Room">
              {rooms.map((room) => (
                <Option key={room._id} value={room.name}>
                  {room.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div className="col-md-6">
          <Form.Item
            name="ratePlan"
            label={<strong>Filter by Rate Plan</strong>}
          >
            <Select placeholder="Select Rate Plan">
              {ratePlans.map((plan) => (
                <Option key={plan._id} value={plan.rateplanname}>
                  {plan.rateplanname}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </div>
        <div className="col-md-6">
          <Form.Item
            name="stayedDateRange"
            label={<strong>Filter by Date Range Stayed Data</strong>}
          >
            <RangePicker format="DD-MM-YYYY" />
          </Form.Item>
        </div>
        <div className="col-md-6">
          <Form.Item
            name="bookedDateRange"
            label={<strong>Filter by Date Range Booked Data</strong>}
          >
            <RangePicker format="DD-MM-YYYY" />
          </Form.Item>
        </div>
      </div>
      <Button type="primary" htmlType="submit" block>
        Submit Filters
      </Button>
      <Button
        type="default"
        onClick={handleResetFilters}
        block
        style={{ marginTop: "10px" }}
      >
        Reset Filters
      </Button>
    </Form>
  );
};
